module.exports = __webpack_public_path__ + "static/media/how_nb.b2791f55.vtt";